import { render, staticRenderFns } from "./EditServiceData.vue?vue&type=template&id=b3253922&scoped=true&"
import script from "./EditServiceData.vue?vue&type=script&lang=js&"
export * from "./EditServiceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3253922",
  null
  
)

export default component.exports